import * as actions from 'actions/PaymentActions/PaymentActions';
import { AsyncStatus } from 'utils/asyncStatusHelper';
import get from 'lodash/get';
import { WalletBalanceMessageType } from 'typings/Payments/PaymentsTypes';
import { RESPONSE_STATUS } from 'pages/PaymentsPage/PaymentOptions/constants';
import { stringTemplate } from 'components/StringWidget/StringWidget';
export const INITIAL_STATE = {};
export default function mobileWalletBalance(state = INITIAL_STATE, action) {
    switch (action.type) {
        case actions.MOBILE_WALLET_BALANCE_REQUEST: {
            return Object.assign(Object.assign({}, state), getWalletBalanceState(action.walletApps, AsyncStatus.LOADING));
        }
        case actions.MOBILE_WALLET_BALANCE_ERROR: {
            return Object.assign(Object.assign(Object.assign({}, state), getWalletBalanceState(action.walletApps, AsyncStatus.ERROR)), action.error);
        }
        case actions.MOBILE_WALLET_BALANCE_SUCCESS: {
            const responseType = get(action, 'data.response_status');
            if (responseType === RESPONSE_STATUS.FAILED) {
                return Object.assign(Object.assign({}, state), getWalletBalanceState(action.walletApps, AsyncStatus.ERROR));
            }
            const walletBalanceState = get(action, 'data.wallet_details', []).reduce((result, detail) => {
                if (detail) {
                    const { balance } = detail;
                    result[detail.app_code] = Object.assign(Object.assign({}, detail), { asyncStatus: AsyncStatus.SUCCESS, balance: balance || balance === 0 ? balance : stringTemplate('walletBalanceUnavailableTitle') });
                }
                return result;
            }, {});
            return Object.assign(Object.assign({}, state), walletBalanceState);
        }
        default:
            return state;
    }
}
function getWalletBalanceState(walletApps, asyncStatus) {
    return walletApps.reduce((result, appCode) => {
        if (asyncStatus === AsyncStatus.ERROR) {
            result[appCode] = {
                asyncStatus,
                balance: stringTemplate('walletBalanceUnavailableTitle'),
                messages: [{ type: WalletBalanceMessageType.INFO, message: stringTemplate('walletBalanceUnavailableMessage') }]
            };
        }
        else {
            result[appCode] = { asyncStatus };
        }
        return result;
    }, {});
}
